package com.ijoin.update

import kotlin.js.Date

actual fun currentTimeMillis(): Long = Date.now().toLong()
